<div class="c-loader-backdrop">
	<div>
		<tvcore-icon name="loader"></tvcore-icon>
		<p>
			<strong>{{ message }}</strong>
		</p>
	</div>
</div>
